import moment from 'moment';
moment.locale('ko');

export const format = {
  methods: {
    addDay(date) {
      if (!date) return;

      const day = moment(date).format('dddd')[0];
      let format = `${date}(${day})`;

      if (date.includes(' ')) {
        format = `${date.split(' ')[0]}(${day}) ${date.split(' ')[1]}`;
      }
      return format;
    },
    phoneFormat(phone) {
      // 널가드 (2026-08-13): null 이면 replace 예외로 화면 백지. 회원프론트와 동일 수정.
      if (!phone) return '';
      return String(phone).replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
    },
  },
};
